import { useTranslation } from 'react-i18next'

import { Box, Button, Stack } from '@mui/material'

import ScheduleIcon from '@mui/icons-material/Schedule'

import dialogHook from '@hooks/useDialog'

import { RequestDemoDialog } from '@components/RequestDemoDialog'
import { TLGTypography } from '@components/TLGTypography'

import {
  containerSx,
  contentDescriptionSx,
  contentSx,
  imageSx,
  scheduleDemoButtonSx,
} from './styles'

const ScheduleADemo = () => {
  const { t } = useTranslation()

  const requestDemoDialog = dialogHook.useDialog()

  return (
    <>
      {requestDemoDialog.isOpen && (
        <RequestDemoDialog
          open={requestDemoDialog.isOpen}
          onClose={requestDemoDialog.close}
        />
      )}

      <Stack data-testid="schedule-a-demo" sx={containerSx}>
        <Box
          loading="lazy"
          component="img"
          src="/images/buyer-dashboard-hero.webp"
          alt={t('Laptop with dashboard')}
          sx={imageSx}
        />
        <Stack sx={contentSx}>
          <Stack sx={contentDescriptionSx}>
            <TLGTypography variant="h4">{t('Schedule a Demo')}</TLGTypography>
            <TLGTypography variant="h6">
              {t(
                'Experience innovation firsthand! Schedule a demo with The Launchpad and discover cutting-edge solutions that will elevate your business to new heights.'
              )}
            </TLGTypography>
          </Stack>

          <Button
            data-testid="schedule-a-demo-button"
            variant="contained"
            color="secondary"
            size="large"
            endIcon={<ScheduleIcon />}
            fullWidth
            onClick={requestDemoDialog.open}
            sx={scheduleDemoButtonSx}
          >
            {t('Schedule a demo now')}
          </Button>
        </Stack>
      </Stack>
    </>
  )
}

export { ScheduleADemo }
